import { render, staticRenderFns } from "./AddExtraCharge.vue?vue&type=template&id=2bc75c1c&scoped=true&"
import script from "./AddExtraCharge.vue?vue&type=script&lang=js&"
export * from "./AddExtraCharge.vue?vue&type=script&lang=js&"
import style0 from "./AddExtraCharge.vue?vue&type=style&index=0&id=2bc75c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc75c1c",
  null
  
)

export default component.exports